import OrdemServicoServicoService from "@/services/OrdemServicoServicoService";

export const ordemServicoServico = {
  namespaced: true,
  state: {
    ordemServicoServico: {},
  },
  actions: {
    getOrdemServicoServico({ commit }, payload) {
      return OrdemServicoServicoService.GetOrdemServicoServico(payload).then(
        (ordemServicoServico) => {
          return Promise.resolve(ordemServicoServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postOrdemServicoServico({ commit }, payload) {
      return OrdemServicoServicoService.PostOrdemServicoServico(payload).then(
        (ordemServicoServico) => {
          return Promise.resolve(ordemServicoServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putOrdemServicoServico({ commit }, payload) {
      return OrdemServicoServicoService.PutOrdemServicoServico(payload).then(
        (ordemServicoServico) => {
          return Promise.resolve(ordemServicoServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteOrdemServicoServico({ commit }, payload) {
      return OrdemServicoServicoService.DeleteOrdemServicoServico(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getOrdemServicoServicoOData({ commit }, payload) {
      return OrdemServicoServicoService.GetOrdemServicoServicoOData(
        payload
      ).then(
        (ordemServicoServico) => {
          return Promise.resolve(ordemServicoServico);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ordemServicoServico;
